import { PrivacyPolicyPage } from './index'

import { RouteFactory } from './../../shared/router/Route.factory'

export default [
  RouteFactory.create(PrivacyPolicyPage, '/privacy-policy', [], {
    name: 'Privacy Policy'
  })
]